import { makeStyles } from "@material-ui/styles";

export const useStyle = makeStyles(() => ({
  claimsheader: {
    background: "#FFFFFF",
    borderRadius: "8px",
  },
  claimstitle: {
    marginLeft: "20px",
    "& h1": {
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.0015em",
      color: "#000000"
    }
  },
  subtitle: {
    marginTop: "4px",
    "& p": {
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.001em",
      color: "#666666",
      margin: 0
    }
  },
  claimswrapper: {
    marginTop: "30px",
    "& button": {
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0.001em",
      color: "#1E1E1E",
      textTransform: "capitalize",
    },
  },
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "#032A37",
    },
    "& .MuiTab-root.Mui-selected": {
      color: "#fff",
      background: "#032A37",
      borderRadius: "8px 8px 0px 0px"
    }
  },
  claimdatawrapper: {
    width: "100%",
    height: "auto",
    paddingBottom: "25px",
    paddingTop: "25px",
    background: "#FFFFFF",
    borderRadius: "8px",
  }
}));